import { Route, Switch, useRouteMatch } from 'react-router-dom';

import Archive from './archive';
import Dashboard from './dashboard';
import React from 'react';
import styled from 'styled-components/macro';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 0;
  position: relative;
  height: calc(100vh - 120px);
  overflow: hidden;
`;

const Routes = () => {
  const { path } = useRouteMatch();

  return (
    <>
      <Switch>
        <Wrapper>
          <Route exact path={path} component={Dashboard} />
          <Route path={`${path}/archive`} component={Archive} />
        </Wrapper>
      </Switch>
    </>
  );
};

export default Routes;
